<template>
  <div>
    <el-dialog v-model="dialogTableVisible" trigger="hover" :title="title" width="800" >
      <el-form :inline="true"  :model="formInline" class="demo-form-inline">
        <el-form-item label="下单平台">
          <el-select
              v-model="formInline.salePlatformId"
              filterable
              allow-create
              default-first-option
              @change="getSelect"
              :reserve-keyword="false"
              placeholder="请选择或添加下单平台"
              style="width: 200px"
          >
            <el-option
                v-for="item in defaultOption"
                :key="item.platformCNName"
                :label="item.platformCNName"
                :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="下单邮箱">
          <el-input style="width:200px" :disabled="disable" v-model="formInline.userEmail" placeholder="请输入下单邮箱" clearable />
        </el-form-item>
        <el-form-item label="订单编号">
          <el-input style="width:200px" v-model="formInline.saleOrder" placeholder="请输入订单编号" clearable />
        </el-form-item>
        <el-form-item v-if="!disable" label="设备序列码" style="width: 200px">
          <div  class="inputDiv" >
            <input class="input" v-model="formInline.materialSn" placeholder="请输入序列码"> <el-icon @click="getSnNumber()"><DocumentAdd /></el-icon>
          </div>
        </el-form-item>
        <el-form-item v-else label="设备序列码">
          <el-input  style="width:200px" disabled v-model="formInline.materialSn" placeholder="请输入序列码" clearable />
        </el-form-item>
        <div>
          <el-form-item label="订单凭证">
            <el-upload v-if=" formInline.orderPicList.length==0"
                       :on-success="getUploadUrl"
                       :before-upload="handleBeforeUpload"
                       v-model:file-list="fileList"
                       :action="uploadUrl"
                       list-type="picture-card"
                       :on-preview="handlePictureCardPreview"
                       :on-remove="handleRemove"
            >
              <el-icon ><Plus /></el-icon>
              <el-dialog class="container" v-model="dialogVisible">
                <img :src="dialogImageUrl" alt="Preview Image" />
              </el-dialog>
            </el-upload>
            <div v-else>
              <myImage v-for="(item,index) in formInline.orderPicList" :key="index"
                       :pictureUrl="item"
                       :pictureUrlList="formInline.orderPicList"
                       :index="index"
              />
            </div>
          </el-form-item>
        </div>
        <div class="flex flex-item-center flex-row-between">
          <el-form-item label="激活时间">
            <el-date-picker
                value-format="YYYY-MM-DD"
                format="YYYY-MM-DD"
                v-model="formInline.activeDate"
                type="date"
                placeholder="激活时间"
                clearable
            />
          </el-form-item>
          <el-form-item  v-if="title=='新建设备激活'">
            <el-button style="margin: 0 auto" type="primary" @click="onSubmit">{{botton}}</el-button>
          </el-form-item>
          <el-form-item v-else>
            <el-button style="margin-right:10px"  type="danger" @click="onSubmit(2)">订单存疑</el-button>
            <el-button  type="primary" @click="onSubmit(1)">{{botton}}</el-button>
          </el-form-item>
        </div>

        <input hidden type="file" @change="handleFileChange" ref="fileInput" />
      </el-form>
    </el-dialog>
  </div>
</template>
<script >
import {ElDialog,ElForm,ElFormItem,ElButton,ElInput,ElSelect,ElOption,ElUpload,ElIcon,ElDatePicker,ElMessage} from "element-plus";
import http from "@/utils/requset";
import {uploadUrl} from "@/utils/requset"
import {getLocalPlatform} from "@/../public/js/index";
import {getFullUrl,isValidEmail} from "@/../public/js/index"
import myImage from "@/components/myImage.vue";
export default {
  name: 'addActiveSale',
  components:{
    ElDialog,ElForm,ElFormItem,ElButton,ElInput,ElSelect,ElOption,ElUpload,ElIcon,ElDatePicker,myImage
  },
  mixins:[getFullUrl,isValidEmail],
  data(){
    return{
      uploadUrl:'',
      disable:false,
      formInline:{orderPicList:[]},
      title:"新建设备激活",
      botton:"激活",
      dialogTableVisible:false,
      defaultOption:[],
      dialogImageUrl:'',
      dialogVisible:false,
      fileList:[],
      fileUrlList:[],
    }
  },
  beforeMount() {
    this.uploadUrl = uploadUrl
    getLocalPlatform().then(res => {
      this.defaultOption = res
      console.log(this.defaultOption)
    })
  },
  methods:{
    getSelect(value){
      console.log(value)
      let option = this.defaultOption.filter(item => {
        return  item.id == value
      })
      this.formInline.salePlatformId = option[0].id
      this.formInline.salePlatform = option[0].platformCNName
    },
    handlePictureCardPreview(uploadFile){
      console.log(uploadFile)
      this.dialogImageUrl = uploadFile.url
      this.dialogVisible = true
    },
    handleRemove(uploadFile, uploadFiles){
      console.log(uploadFile, uploadFiles)
      let fullUrl = getFullUrl(uploadFile.response.location)
      this.fileUrlList = this.fileUrlList.filter(item=>{
        return  item!=fullUrl
      })
    },
    open(data){
      this.fileList = []
      this.fileUrlList = []
      this.dialogTableVisible = true
      console.log(data)
      if(data && data.id){
        this.title = "设备保修激活审核"
        this.botton = "确认通过"
        this.disable = true
        this.formInline = data
        this.fileUrlList = data.orderPicList
      }else{
        this.title = "新建设备激活"
        this.botton = "激活"
        this.disable = false
        this.formInline = {orderPicList:[]}
      }
    },
    onSubmit(data){
      if(this.title == "新建设备激活"){
        if(!this.formInline.salePlatform){
          ElMessage.warning('请填写销售平台')
          return false
        }
        if(!this.formInline.userEmail){
          ElMessage.warning('请填写联系邮箱')
          return false
        }else {
          if(!isValidEmail(this.formInline.userEmail)){
            ElMessage.warning('请填写正确的邮箱地址')
            return false
          }
        }
        if(!this.formInline.saleOrder){
          ElMessage.warning('请填写销售订单')
          return false
        }
        if(!this.formInline.materialSn){
          ElMessage.warning('请填写SN序列码')
          return false
        }
        if(!this.fileUrlList){
          ElMessage.warning('请上传订单图片')
          return false
        }
      }
      if(!this.formInline.activeDate){
        ElMessage.warning('请选择激活时间')
        return false
      }
      if(this.botton=="激活"){
        http.post('/after/addActiveSale',{...this.formInline,orderPicList:this.fileUrlList} ).then((res)=>{
          console.log(res)
          this.dialogTableVisible = false;
          this.$emit('closeEdit')
        }).catch((err)=>{
          console.log(err)
        })
      }else{
        http.post('/after/updateActiveStatus',{
          id:this.formInline.id,
          "saleOrder":this.formInline.saleOrder,
          "salePlatformId":this.formInline.salePlatformId,
          "salePlatform":this.formInline.salePlatform,
          "activeDate":this.formInline.activeDate,
          "updateActiveStatus":data} ).then((res)=>{
          console.log(res)
          this.dialogTableVisible = false;
          this.$emit('closeEdit')
        }).catch((err)=>{
          console.log(err)
        })
      }

    },
    getUploadUrl(response){
      console.log(response)
      //this.fileUrlList.push(getFullUrl(response.location))
      this.fileUrlList.push(response.location)
      console.log(this.fileList)
      console.log(this.fileUrlList)
    },
    handleBeforeUpload(file){
      const isJPGOrPNG = file.type === 'image/jpeg' || file.type === 'image/png';
      if (!isJPGOrPNG) {
        ElMessage.error('上传头像图片只能是 JPG/PNG 格式!');
        return false; // 不上传该文件
      } else if (file.size / 1024 / 1024 > 8) {
        ElMessage.error('图片上传大小不超过8M!')
        return false
      }
    },
    getSnNumber(){
      this.$refs.fileInput.click()
    },
    handleFileChange(event){
      const file = event.target.files[0]; // 获取第一个文件
      const isJPGOrPNG = file.type === 'image/jpeg' || file.type === 'image/png';
      if (!isJPGOrPNG) {
        ElMessage.error('上传头像图片只能是 JPG/PNG 格式!');
        return false; // 不上传该文件
      } else if (file.size / 1024 / 1024 > 8) {
        ElMessage.error('图片上传大小不超过8M!')
        return false
      }
      const formData = new FormData();
      formData.append('file', file);
      formData.append('isSn',true);
      http.post(uploadUrl,formData, {}).then(res=>{
        this.formInline.materialSn = res.data
      }).catch(err=>{
        console.log(err)
      })
    }
  }
}
</script>
<style scoped>
::v-deep .el-form-item__label{
  width: 100px;
}
::v-deep .el-form-item__content{
  flex: unset;
}
.avatar-uploader .el-upload {
  border: 1px dashed var(--el-border-color);
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: var(--el-transition-duration-fast);
}

.avatar-uploader .el-upload:hover {
  border-color: var(--el-color-primary);
}

.el-icon.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  text-align: center;
  border: 1px #999999 dashed;
}
.inputDiv{
  width:178px;
  align-items: center;
  background-color: var(--el-input-bg-color, var(--el-fill-color-blank));
  background-image: none;
  border-radius: var(--el-input-border-radius, var(--el-border-radius-base));
  box-shadow: 0 0 0 1px var(--el-input-border-color, var(--el-border-color));
  cursor: text;
  display: inline-flex;
  flex-grow: 1;
  justify-content: center;
  padding: 1px 11px;
  transform: translateZ(0);
  transition: var(--el-transition-box-shadow);
}
.input{
  width: 178px;
  -webkit-appearance: none;
  background: none;
  border: none;
  box-sizing: border-box;
  color: var(--el-input-text-color, var(--el-text-color-regular));
  flex-grow: 1;
  font-size: inherit;
  height: var(--el-input-inner-height);
  line-height: var(--el-input-inner-height);
  outline: none;
  padding: 0;
}
</style>